import { render, staticRenderFns } from "./ModuloForm.vue?vue&type=template&id=0685ba5a&scoped=true"
import script from "./ModuloForm.vue?vue&type=script&lang=js"
export * from "./ModuloForm.vue?vue&type=script&lang=js"
import style0 from "./ModuloForm.vue?vue&type=style&index=0&id=0685ba5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0685ba5a",
  null
  
)

export default component.exports